import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ExcelgeneratorService } from 'src/app/services/excelgenerator/excelgenerator.service';
import { OrderService } from 'src/app/services/order/order.service';
import { UsersService } from 'src/app/services/users/users.service';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component';
import { NgxDateRangePickerOptions } from '../schedulingandplanning/createtriptable/createtriptable.component';
import { TripdetailsComponent } from '../trip/tripdetails/tripdetails.component';
import { MapComponent } from '../tripdetailreport/mapcomponent/map.component';
import { CdkDetailRowDirective } from '../userreport/cdk-detail.row';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-marketingboyreport',
  templateUrl: './marketingboyreport.component.html',
  styleUrls: ['../userreport/userreport.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class MarketingboyreportComponent implements OnInit {

  columnsToDisplay = [
    'user',
    'date',
    'onDutyTime',
    'offDutyTime',
    'dutyHours',
    'kms',
    'visited',
    'totalPicked',
    'totalTrips',
    'active',
    'currentLocation',
    // 'cancelled'
  ];
  userActivityData = new MatTableDataSource;
  options: NgxDateRangePickerOptions;
  dateRangevalue;
  isDateFiltered = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  fromDate: any;
  toDate: any;
  totalRecords = 0;
  private openedRow: CdkDetailRowDirective;
  isLoading: boolean = false;
  excelRecords = [];
  excelDailyRecords = [];
  isRunnerBoyReport: boolean = false;
  
  constructor(
    private datePipe: DatePipe,
    private userService: UsersService,
    public dialog: MatDialog,
    private excelService: ExcelgeneratorService,
    private decimalPipe: DecimalPipe,
    private orderService: OrderService
  ) { }

  ngOnInit(): void {
    // this.createInitialFilter();
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.getUserActivityData();
  }

  ngAfterViewInit() {
    this.userActivityData.paginator = this.paginator;
    this.userActivityData.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'user': return item.userSummaryReport.fullName;
      }
    };
    this.userActivityData.sort = this.sort;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective): void {
    if (this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  applyFilter(filterValue: string) {
    this.userActivityData.filter = filterValue.trim().toLowerCase();
    this.userActivityData.filterPredicate = (data: any, filter: string) => {
      let isUserName = false, isDepartment = false;
      if (data) {
        if (data.userSummaryReport && data.userSummaryReport.fullName) {
          isUserName = data.userSummaryReport.fullName.toString().toLowerCase().indexOf(filter) != -1;
        }
        if (data.userSummaryReport && data.userSummaryReport.roleName) {
          isDepartment = data.userSummaryReport.roleName.toString().toLowerCase().indexOf(filter) != -1;
        }
      }
      return isUserName || isDepartment;
    };
  }

  sortByDate(event: MatDatepickerInputEvent<Date>) {
    this.fromDate = this.datePipe.transform(new Date(event.value), 'yyyy-MM-dd');
    this.getUserActivityData();
  }


  getUserActivityData() {
    this.isLoading = true;
    this.userActivityData.data = [];
    this.userService.getUserReport(this.fromDate).subscribe(activity => {
      this.isLoading = false;
      if (activity) {
        this.userActivityData.data = activity.filter(activity => activity.userSummaryReport.roleName == "Marketing");
        this.totalRecords = this.userActivityData.data.length;
        console.log("User Data", this.userActivityData.data);
      } else {
        this.userActivityData.data = [];
        this.totalRecords = 0;
      }
    }, () => {
      this.isLoading = false;
      this.userActivityData.data = [];
      this.totalRecords = 0;
    });
  }

  openMap(userName,tripName: string, onDutyLocation, offDutyLocation, onDutyAdress, offDutyAddress) {
    let mapDialog, ondutyLoc, offDutyLoc;
    if (onDutyLocation)
      ondutyLoc = onDutyLocation.split(',')
    if (offDutyLocation)
      offDutyLoc = offDutyLocation.split(',')
    mapDialog = this.dialog.open(MapComponent, {
      width: '800px',
      data: {
        userName: userName,
        tripName: tripName,
        onDutyLocation: ondutyLoc,
        offDutyLocation: offDutyLoc,
        onDutyAddress: onDutyAdress,
        offDutyAdress: offDutyAddress
      }
    });

    mapDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  orderDetails(orderid) {
    this.orderService.getOrderDetails(Number(orderid) + 1).subscribe(orderData => {
      let editDialog = this.dialog.open(AllorderdetailsComponent, {
        width: '800px',
        data: {
          data: orderData,
        }
      });
      editDialog.updatePosition({
        top: '50px', right: '0px',
      });
    })
  }

  tripDetails(tripId) {
    let tripdialog = this.dialog.open(TripdetailsComponent, {
      width: '800px',
      data: {
        component: 'userreport',
        tripid: tripId,
      }
    });
    tripdialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'userReport');
  }

  dataForExcel() {
    let userData = [];
    userData = this.userActivityData.data;
    this.excelRecords = [];
    userData.forEach(user => {
      if (user) {
        if (user.userDailyReport.length > 0) {
          let count = 0;
          user.userDailyReport.forEach(report => {
            if (count == 0) {
              this.excelRecords.push({
                'User': user.userSummaryReport.fullName,
                'Phone No.': user.userSummaryReport.phoneNumber,
                'Date': this.datePipe.transform(user.userSummaryReport.onDutyDateTime, "dd/MM/yyyy"),
                'On Duty': this.datePipe.transform(user.userSummaryReport.onDutyDateTime, "medium"),
                'On Duty Address': user.userSummaryReport.onDutyAddress || '',
                'Off Duty': this.datePipe.transform(user.userSummaryReport.offDutyDateTime, "medium"),
                'Off Duty Address': user.userSummaryReport.offDutyAddress || '',
                'Duty Hours': this.minsToHours(user.userSummaryReport.dutyMinutes) || '',
                'KMs': this.decimalPipe.transform(user.userSummaryReport.totalKms, "1.2-2"),
                'Visited': user.userSummaryReport.totalVisited,
                'Picked': user.userSummaryReport.totalSamplePickups,
                'Trips': user.userSummaryReport.totalTrips,
                'Name': report.receiverName,
                'Trip': report.tripID,
                'Trip Start': this.datePipe.transform(report.tripStartDateTime, "medium"),
                'Order': report.orderID,
                'Time Diff': report.timeDiff,
                'KMS Diff': report.kmsDiff,
                'Visit Address': report.pickUpAddress,
                'Visit Time': report.deliveryTime,
                'Status': report.orderState,
                'Comments': report.comments,
              });
            }
            else {
              this.excelRecords.push({
                'User': user.userSummaryReport.fullName,
                'Phone No.': user.userSummaryReport.phoneNumber,
                'Date': this.datePipe.transform(user.userSummaryReport.onDutyDateTime, "dd/MM/yyyy"),
                'On Duty': this.datePipe.transform(user.userSummaryReport.onDutyDateTime, "medium"),
                'On Duty Address': user.userSummaryReport.onDutyAddress || '',
                'Off Duty': this.datePipe.transform(user.userSummaryReport.offDutyDateTime, "medium"),
                'Off Duty Address': user.userSummaryReport.offDutyAddress || '',
                'Duty Hours': '',
                'KMs': '',
                'Visited': '',
                'Picked': '',
                'Trips': '',
                'Name': report.receiverName,
                'Trip': report.tripID,
                'Trip Start': this.datePipe.transform(report.tripStartDateTime, "medium"),
                'Order': report.orderID,
                'Time Diff': report.timeDiff,
                'KMS Diff': report.kmsDiff,
                'Visit Address': report.pickUpAddress,
                'Visit Time': report.deliveryTime,
                'Status': report.orderState,
                'Comments': report.comments,
              });
            }
            count = count + 1;
          });
        }
        else {
          this.excelRecords.push({
            'User': user.userSummaryReport.fullName,
            'Phone No.': user.userSummaryReport.phoneNumber,
            'Date': this.datePipe.transform(user.userSummaryReport.onDutyDateTime, "dd/MM/yyyy"),
            'On Duty': this.datePipe.transform(user.userSummaryReport.onDutyDateTime, "medium"),
            'Off Duty': this.datePipe.transform(user.userSummaryReport.offDutyDateTime, "medium"),
            'Duty Hours': this.minsToHours(user.userSummaryReport.dutyMinutes) || '',
            'KMs': this.decimalPipe.transform(user.userSummaryReport.totalKms, "1.2-2"),
            'Visited': user.userSummaryReport.totalVisited,
            'Picked': user.userSummaryReport.totalSamplePickups,
            'Trips': user.userSummaryReport.totalTrips,
          });
        }
      }

    });
  }

  minsToHours(totalMins) {
    if (totalMins) {
      var num = totalMins;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return rhours + " : " + rminutes;
    }
    else {
      return 0;
    }
  }
}